<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == "ven-funil") {
            next({ name: "ven-funil-list" });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == "ven-funil") {
            this.$router.push({ name: "ven-funil-list" });
        }
    },
};
</script>